module.exports = __webpack_public_path__ + "static/decoracion-2.8ae70b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/decoracion-2.jpg
// module id = 138
// module chunks = 8519208414936 48515692054781